import React from 'react';
import SocialShare from '../../../frontastic/tastics/social-share';

const AmplienceSocialShare: React.FC = () => <SocialShare />;

export default AmplienceSocialShare;
